"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ckeditor5React = require("@ckeditor/ckeditor5-react");

var _classiceditor = _interopRequireDefault(require("@ckeditor/ckeditor5-editor-classic/src/classiceditor"));

var _essentials = _interopRequireDefault(require("@ckeditor/ckeditor5-essentials/src/essentials"));

var _paragraph = _interopRequireDefault(require("@ckeditor/ckeditor5-paragraph/src/paragraph"));

var _list = _interopRequireDefault(require("@ckeditor/ckeditor5-list/src/list"));

var _bold = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/bold"));

var _italic = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/italic"));

var _underline = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/underline"));

var _font = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/font"));

var _alignment = _interopRequireDefault(require("@ckeditor/ckeditor5-alignment/src/alignment"));

var _image = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/image"));

var _imageupload = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageupload"));

var _imageresize = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageresize"));

var _imagetoolbar = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagetoolbar"));

var _imagestyle = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagestyle"));

var _linkimage = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/linkimage"));

var _base64uploadadapter = _interopRequireDefault(require("@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter"));

var _link = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/link"));

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var _Attachments = _interopRequireDefault(require("../Attachment/Attachments"));

var _variablesPlaceholder = _interopRequireDefault(require("./plugins/variablesPlaceholder"));

var _grooveImage = _interopRequireDefault(require("./plugins/grooveImage"));

var _Editor = require("./Editor.styles");

// To override the default styles, this file must be imported after ClassicEditor.
var Editor = function Editor(_ref) {
  var onEditorDataChange = _ref.onEditorDataChange,
      editorData = _ref.editorData,
      className = _ref.className,
      placeholder = _ref.placeholder,
      showAddAttachment = _ref.showAddAttachment,
      attachments = _ref.attachments,
      setAttachments = _ref.setAttachments,
      onUploadFile = _ref.onUploadFile,
      onAttachmentRemove = _ref.onAttachmentRemove,
      showPluginVariablesPlaceholder = _ref.showPluginVariablesPlaceholder,
      showPluginImageUpload = _ref.showPluginImageUpload,
      pluginVariablesPlaceholderTypes = _ref.pluginVariablesPlaceholderTypes,
      disabled = _ref.disabled,
      help = _ref.help,
      validateStatus = _ref.validateStatus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onReady = _ref.onReady,
      isToolbarHidden = _ref.isToolbarHidden,
      maxUploadSize = _ref.maxUploadSize,
      maxInlineImageSize = _ref.maxInlineImageSize,
      height = _ref.height,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight;
  var editorToolbar = (0, _react.useMemo)(function () {
    var toolbar = ['bold', 'underline', 'italic', '|', 'alignment', '|', 'fontColor', 'fontBackgroundColor', '|', 'numberedList', 'bulletedList', '|', 'link'];

    if (showPluginImageUpload) {
      // TODO: need to have an image uploader api, and then create a custom Upload adapter
      // to handle showing and uploading image
      toolbar.push('grooveUploadImage');
    }

    if (showPluginVariablesPlaceholder) {
      // add divider
      toolbar.push('|');
      toolbar.push('placeholder');
    }

    return toolbar;
  }, [showPluginVariablesPlaceholder, showPluginImageUpload]);
  var editorPlugins = (0, _react.useMemo)(function () {
    var plugins = isToolbarHidden ? [_essentials["default"], _paragraph["default"]] : [_essentials["default"], _paragraph["default"], _alignment["default"], _font["default"], _list["default"], _bold["default"], _italic["default"], _underline["default"], _link["default"], _image["default"], _imageresize["default"], _imagetoolbar["default"], _imagestyle["default"], _linkimage["default"]];

    if (showPluginImageUpload) {
      plugins.push(_base64uploadadapter["default"]);
      plugins.push(_imageupload["default"]);
      plugins.push(_grooveImage["default"]);
    }

    if (showPluginVariablesPlaceholder) {
      // For inserting variables feature
      plugins.push(_variablesPlaceholder["default"]);
    }

    return plugins;
  }, [isToolbarHidden, showPluginImageUpload, showPluginVariablesPlaceholder]);
  var editorConfig = (0, _react.useMemo)(function () {
    var config = {
      plugins: editorPlugins,
      toolbar: !isToolbarHidden && editorToolbar,
      placeholder: placeholder
    };

    if (showPluginImageUpload) {
      Object.assign(config, {
        grooveImagePluginConfig: {
          EDITOR_MAX_INLINE_IMAGE_SIZE: maxInlineImageSize,
          EDITOR_MAX_UPLOAD_SIZE: maxUploadSize,
          onInlineImageTooLarge: onUploadFile,
          onFileTooLarge: setAttachments
        }
      });
    }

    if (showPluginVariablesPlaceholder) {
      // Config insert variables list
      Object.assign(config, {
        variablesPlaceholderPluginConfig: {
          types: pluginVariablesPlaceholderTypes
        }
      });
    }

    return config;
  }, [editorPlugins, isToolbarHidden, editorToolbar, placeholder, showPluginVariablesPlaceholder, pluginVariablesPlaceholderTypes, showPluginImageUpload, setAttachments, onUploadFile, maxUploadSize, maxInlineImageSize]);
  var heightStyles = (0, _react.useMemo)(function () {
    return _Editor.styles.size({
      minHeight: minHeight,
      height: height,
      maxHeight: maxHeight
    });
  }, [minHeight, height, maxHeight]);
  return (0, _jsxRuntime.jsxs)("div", {
    children: [(0, _jsxRuntime.jsxs)("div", {
      css: [_Editor.styles.base, isToolbarHidden && _Editor.styles.toolbarHidden, heightStyles, process.env.NODE_ENV === "production" ? "" : ";label:Editor;"],
      className: className,
      children: [(0, _jsxRuntime.jsx)(_ckeditor5React.CKEditor, {
        editor: _classiceditor["default"],
        config: editorConfig,
        data: editorData,
        onChange: onEditorDataChange,
        disabled: disabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onReady: onReady
      }), attachments && !!attachments.length && (0, _jsxRuntime.jsx)(_Attachments["default"], {
        attachments: attachments,
        onAttachmentsChange: setAttachments,
        className: "grui px-10 mb-5",
        onUploadFile: onUploadFile,
        onRemove: onAttachmentRemove,
        disabled: disabled
      })]
    }), showAddAttachment && (0, _jsxRuntime.jsx)(_Attachments["default"].AddAttachments, {
      className: "grui mt-10",
      attachments: attachments,
      onAttachmentsChange: setAttachments,
      onUploadFile: onUploadFile,
      disabled: disabled,
      maxSize: maxUploadSize
    }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
      help: help,
      validateStatus: validateStatus
    })]
  });
};

Editor.propTypes = {
  /**
   * Callback for handling editor data change
   * Function(event, editor)
   */
  onEditorDataChange: _propTypes.func,

  /**
   * Editor data
   */
  editorData: _propTypes.string,
  className: _propTypes.string,

  /**
   * Placeholder for editable area
   */
  placeholder: _propTypes.string,
  onUploadFile: _propTypes.func,
  onAttachmentRemove: _propTypes.func,
  showAddAttachment: _propTypes.bool,
  attachments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  setAttachments: _propTypes.func,
  showPluginVariablesPlaceholder: _propTypes.bool,
  showPluginImageUpload: _propTypes.bool,
  pluginVariablesPlaceholderTypes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string
  })),
  disabled: _propTypes.bool,
  help: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  onBlur: _propTypes.func,
  onFocus: _propTypes.func,
  // Function(editor)
  onReady: _propTypes.func,
  // No toolbar and formatting, only use it as a contenteditable div
  // when need to use the variablesPlaceholder plugin too
  isToolbarHidden: _propTypes.bool,
  maxUploadSize: _propTypes.number,
  maxInlineImageSize: _propTypes.number,
  minHeight: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  height: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  maxHeight: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
Editor.defaultProps = {
  onEditorDataChange: function onEditorDataChange() {},
  editorData: '',
  className: undefined,
  placeholder: 'Type your reply here…',
  showAddAttachment: false,
  attachments: [],
  setAttachments: function setAttachments() {},
  onUploadFile: function onUploadFile() {},
  onAttachmentRemove: function onAttachmentRemove() {},
  showPluginVariablesPlaceholder: false,
  showPluginImageUpload: false,
  pluginVariablesPlaceholderTypes: [],
  disabled: false,
  help: undefined,
  validateStatus: undefined,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onReady: function onReady() {},
  isToolbarHidden: false,
  maxUploadSize: 900 * 1024,
  maxInlineImageSize: 100 * 1024,
  minHeight: '60px',
  height: undefined,
  maxHeight: undefined
};
var _default = Editor;
exports["default"] = _default;
//# sourceMappingURL=Editor.js.map